import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import './Message.css';

const API_URL = 'https://weynibirhan.com.et/contact.php';

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [filter, setFilter] = useState(null); // null = all, 0 = unviewed, 1 = viewed
  const [loading, setLoading] = useState(false);

  // Memoized fetch function
  const fetchContacts = useCallback(async () => {
    setLoading(true);
    try {
      let url = API_URL;
      if (filter !== null) url += `?viewed=${filter}`;
      
      const response = await axios.get(url);
      if (response.data.status === 'success') {
        setContacts(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch contacts:', error);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  const markAsViewed = async (id) => {
    try {
      const response = await axios.put(`${API_URL}?id=${id}`);
      if (response.data.status === 'success') {
        fetchContacts(); // Refresh list
      }
    } catch (error) {
      alert('Error updating status');
    }
  };

  const deleteMessage = async (id) => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      try {
        const response = await axios.delete(`${API_URL}?id=${id}`);
        if (response.data.status === 'success') {
          fetchContacts(); // Refresh list
        }
      } catch (error) {
        alert('Error deleting message');
      }
    }
  };

  return (
    <div className="contact-list-container">
      <h2>Admin Contact Panel</h2>

      <div className="filter-buttons">
        <button className={filter === null ? 'active' : ''} onClick={() => setFilter(null)}>All</button>
        <button className={filter === 0 ? 'active' : ''} onClick={() => setFilter(0)}>Not Viewed</button>
        <button className={filter === 1 ? 'active' : ''} onClick={() => setFilter(1)}>Viewed</button>
      </div>

      {loading ? <p>Loading...</p> : (
        <div className="table-responsive">
          <table className="contact-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Subject</th>
                <th>Message</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contacts.length > 0 ? contacts.map((c, index) => (
                <tr key={c.id} className={c.viewed === "1" || c.viewed === 1 ? 'viewed-row' : ''}>
                  <td>{index + 1}</td>
                  <td>{c.name}</td>
                  <td>{c.email}</td>
                  <td>{c.phone}</td>
                  <td>{c.subject}</td>
                  <td>{c.message}</td>
                  <td>{new Date(c.created_at).toLocaleString()}</td>
                  <td>{ (c.viewed === "1" || c.viewed === 1) ? '✅ Viewed' : '✉️ New'}</td>
                  <td>
                    {!(c.viewed === "1" || c.viewed === 1) && (
                      <button onClick={() => markAsViewed(c.id)} className="action-btn">Mark as Viewed</button>
                    )}
                    <button onClick={() => deleteMessage(c.id)} className="delete-btn">Delete</button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan="9">No messages found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ContactList;